<template>
  <div id="app">
    <!-- 顶部栏 -->
    <div class="top-service-bar" v-if="!isPlayerPage">
      <div class="service-info">
        <table class="service-table">
          <tr>
            <td class="label" rowspan="2">投诉咨询：</td>
            <td class="value"><span class="value-label">QQ：</span><span class="value-text">1094264878</span></td>
          </tr>
          <tr>
            <td class="value"><span class="value-label service-wx-label">VX：</span><span class="value-text">xyk0031</span></td>
          </tr>
        </table>
      </div>
      <div class="brand-wrap">
        <img src="@/assets/logo.png" alt="" class="img" />
        <span class="brand-name">H课堂</span>
      </div>
      <div class="account-entry">
        <!-- 根据登录状态显示不同内容 -->
        <div v-if="isLoggedIn" class="user-info">
          <span class="welcome-text">欢迎，{{ userName }}</span>
          <el-button type="text" @click="handleLogout" class="logout-btn">退出</el-button>
        </div>
        <div v-else>
          <el-button icon="el-icon-user-solid" class="button" @click="showLoginDialog = true">登录</el-button>
        </div>
      </div>
    </div>
    <!-- 导航菜单 -->
    <div class="navigation-menu" v-if="!isPlayerPage">
      <span v-for="(item, i) in navItems" @click="navchandle(item, i)"
        :class="[activeNavIndex === i ? 'nvaActive' : '']" :key="i" :href="item.path">
        {{ item.name }}
      </span>
    </div>
    <div class="content">
      <router-view />
    </div>
    <!-- 底部 -->
    <div class="bottom">
      <div class="bottom-box">
        <div class="bottom-type">
          <span>首页</span>
          <span>课程</span>
          <span>作品</span>
          <span>团队</span>
          <span>新闻</span>
          <span>个人中心</span>
        </div>
        <div class="copyright">
          Copyright © 2024　课程内容版权均归 <a href="">H课堂</a> 所有
          <a href="">用户服务协议</a> 备案号：<a href="">豫ICP备2024098842号</a>
          技术支持：<a href="">景运科技</a>
        </div>
      </div>
    </div>

    <!-- 登录弹窗 -->
    <LoginDialog v-model="showLoginDialog" @login-success="handleLoginSuccess" />
  </div>
</template>

<script>
// import LoginDialog from '@/components/LoginDialog.vue';
import { getUserProfile, logout } from "@/api/index.js";

export default {
  name: "app",
  components: {
    // LoginDialog
  },
  data() {
    return {
      navItems: [
        { name: "首页", path: "/home" },
        { name: "课程", path: "/course" },
        { name: "作品", path: "/production" },
        { name: "团队", path: "/team" },
        { name: "新闻", path: "/news" },
        { name: "个人中心", path: "/profile" },
      ], // 导航项数据数组
      activeNavIndex: 0, // 当前激活的导航项索引
      showLoginDialog: false // 控制登录弹窗显示
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    userName() {
      const userInfo = this.$store.getters.userInfo;
      return userInfo.name || userInfo.username || '用户';
    },
    isPlayerPage() {
      return this.$route.path === '/player';
    }
  },
  created() {
    this.activeNavIndex = this.$store.state.activeNavIndex;

    console.log('App.vue创建，当前登录状态:', {
      isLoggedIn: this.isLoggedIn,
      userToken: this.$store.getters.userToken,
      refreshToken: this.$store.getters.refreshToken
    });

    // 如果已登录，获取用户信息
    if (this.isLoggedIn) {
      this.fetchUserInfo();
    }

    // 监听token过期事件，直接显示登录弹窗
    window.addEventListener('token-expired-show-login', this.handleTokenExpiredShowLogin);
  },
  beforeDestroy() {
    // 清理事件监听器
    window.removeEventListener('token-expired-show-login', this.handleTokenExpiredShowLogin);
  },
  methods: {
    navchandle(item, i) {
      // 如果点击个人中心，检查登录状态
      if (item.name === '个人中心') {
        if (!this.isLoggedIn) {
          this.showLoginDialog = true;
          return;
        }
      }

      // 检查是否已经在目标页面
      if (this.$route.path === item.path) {
        // 如果已经在目标页面，只更新激活状态，不进行路由跳转
        this.activeNavIndex = i;
        this.$store.commit("activeNavIndex", i);
        return;
      }

      if (this.activeNavIndex != i) {
        this.activeNavIndex = i;
        this.$store.commit("activeNavIndex", i);

        // 使用 catch 捕获路由重复错误
        this.$router.push(item.path).catch(err => {
          // 忽略 NavigationDuplicated 错误
          if (err.name !== 'NavigationDuplicated') {
            console.error('路由跳转错误:', err);
          }
        });
      }
    },

    handleLoginSuccess(loginInfo) {
      console.log('登录成功:', loginInfo);

      // 使用Vuex action保存登录状态
      this.$store.dispatch('login', {
        token: loginInfo.token,
        refreshToken: loginInfo.refreshToken,
        userType: loginInfo.userType,
        userId: loginInfo.userId,
        tenantId: loginInfo.tenantId,
        userInfo: {}
      });

      // 获取用户详细信息
      this.fetchUserInfo();
      this.$message.success('登录成功，欢迎回来！');

      // 登录成功后跳转到个人中心
      this.$nextTick(() => {
        // 设置个人中心为激活状态
        this.activeNavIndex = 5; // 个人中心的索引是5
        this.$store.commit("activeNavIndex", 5);

        // 跳转到个人中心
        this.$router.push('/profile').catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error('路由跳转错误:', err);
          }
        });
      });
    },

    fetchUserInfo() {
      if (!this.isLoggedIn) return;

      getUserProfile().then((res) => {
        if (res.data) {
          // 使用Vuex action更新用户信息
          this.$store.dispatch('updateUserInfo', res.data);
        }
      }).catch(error => {
        console.error('获取用户信息失败:', error);
        // 如果获取用户信息失败，可能是token过期，清除登录状态
        this.clearLoginState();
      });
    },

    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        logout().then(() => {
          this.clearLoginState();
          this.$message.success('已退出登录');

          // 如果当前在个人中心页面，跳转到首页
          if (this.$route.path === '/profile') {
            this.activeNavIndex = 0;
            this.$store.commit("activeNavIndex", 0);
            this.$router.push('/home').catch(err => {
              if (err.name !== 'NavigationDuplicated') {
                console.error('路由跳转错误:', err);
              }
            });
          }
        }).catch(error => {
          console.error('退出登录失败:', error);
          // 即使接口失败，也清除本地存储
          this.clearLoginState();
          this.$message.success('已退出登录');

          // 如果当前在个人中心页面，跳转到首页
          if (this.$route.path === '/profile') {
            this.activeNavIndex = 0;
            this.$store.commit("activeNavIndex", 0);
            this.$router.push('/home').catch(err => {
              if (err.name !== 'NavigationDuplicated') {
                console.error('路由跳转错误:', err);
              }
            });
          }
        });
      });
    },

    clearLoginState() {
      // 使用Vuex action清除登录状态
      this.$store.dispatch('logout');
    },

    handleTokenExpiredShowLogin() {
      // token过期后直接显示登录弹窗
      console.log('Token过期，显示登录弹窗');

      // 显示登录弹窗
      this.showLoginDialog = true;
    }
  },
  watch: {
    '$store.state.activeNavIndex': {
      handler(newValue, oldValue) {
        this.activeNavIndex = newValue;
      },
      deep: true
    },

    // 监听路由变化，更新导航状态
    '$route'(to, from) {
      // 如果要访问个人中心但未登录，显示登录弹窗
      if (to.path === '/profile' && !this.isLoggedIn) {
        this.showLoginDialog = true;
        return;
      }

      // 根据当前路由更新导航索引
      const routeIndex = this.navItems.findIndex(item => item.path === to.path);
      if (routeIndex !== -1) {
        this.activeNavIndex = routeIndex;
        this.$store.commit("activeNavIndex", routeIndex);
      }
    }
  }
};
</script>

<style lang="scss">
/* 顶部服务栏样式 */
.top-service-bar {
  border: 1px;
  padding: 25px 0 10px;
  color: #666;
  display: flex;
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;
  width: 1000px;
  height: 70px;
  clear: both;

  .service-info,
  .brand-wrap,
  .account-entry {
    flex: 1;
    display: flex;
    align-items: center;
  }

  .service-info {
    justify-content: flex-start;
  }

  .brand-wrap {
    justify-content: center;
    gap: 12px;
  }

  .account-entry {
    justify-content: flex-end;
  }

  .img {
    width: 80px;
    height: 70px;
  }

  .brand-name {
    font-size: 34px;
    font-weight: 600;
    color: #333;
    letter-spacing: 2px;
    line-height: 1;
  }

  span {
    font-size: 16px;
    color: black;
    font-family: "Microsoft YaHei";
  }

  .service-table {
    border-collapse: collapse;
    font-size: 16px;
    color: black;
    font-family: "Microsoft YaHei";
  }

  .service-table td {
    padding: 1px 4px;
  }

  .service-table .label {
    white-space: nowrap;
    padding-right: 4px;
  }

  .service-table .value {
    text-align: left;
  }

  .service-table .value-label {
    display: inline-block;
    width: 40px;
    margin-right: 4px;
  }

  .service-table .service-wx-label {
    padding-left: 2px;
    letter-spacing: 1.5px;
  }

  .button {
    cursor: pointer;
    border: none;
    font-size: 21px;
  }

  .user-info {
    display: flex;
    align-items: center;
    gap: 15px;

    .welcome-text {
      font-size: 16px;
      color: #333;
    }

    .logout-btn {
      padding: 8px 16px;
      font-size: 14px;
      color: #666;

      &:hover {
        color: #409eff;
      }
    }
  }
}

/* 导航菜单样式 */
.navigation-menu {
  margin: 20px auto;
  width: 700px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-size: 18px;
  clear: both;

  span {
    cursor: pointer;
    transition: color 0.3s ease;

    &:hover {
      color: #409eff;
    }
  }

  .nvaActive {
    color: red;
    font-weight: 600;
  }
}

/* 底部样式 */
.bottom {
  background-color: #282828;

  .bottom-box {
    margin: 0 auto;

    width: 1200px;
    padding: 50px 0 0 0;

    .bottom-type {
      display: flex;
      height: 55px;
      align-items: center;

      span {
        margin: 0 60px 40px 0;
        color: #747474;
        font-size: 14px;
        font-family: "Microsoft YaHei";
        cursor: pointer;
      }
    }

    .copyright {
      color: #747474;
      font-size: 14px;
      font-family: "Microsoft YaHei";
      width: 1200px;
      text-align: left;
      height: 76px;
      line-height: 76px;
      border-top: 1px solid #444444;

      a {
        color: #747474;
      }
    }
  }
}

#app {
  text-align: center;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.content {
  flex: 1;
}

body {
  margin: 0px;
  padding: 0px;
}
</style>

<style lang="scss">
/* 移动端自适应覆盖样式 */
* {
  box-sizing: border-box;
}

@media (max-width: 1200px) {

  /* 顶部、导航、底部容器在小屏改为自适应宽度 */
  .top-service-bar,
  .navigation-menu,
  .bottom .bottom-box,
  .bottom .bottom-box .copyright {
    max-width: 100% !important;
    width: 100% !important;
    padding-left: 12px;
    padding-right: 12px;
  }

  /* 顶部栏在小屏分行显示 */
  .top-service-bar {
    justify-content: space-between;
  }
}

@media (max-width: 992px) {
  .top-service-bar {
    flex-direction: column;
    align-items: center;
    height: auto;
    gap: 12px;
  }

  .top-service-bar .service-info,
  .top-service-bar .brand-wrap,
  .top-service-bar .account-entry {
    width: 100%;
    justify-content: center;
  }

  .navigation-menu {
    width: 100% !important;
    flex-wrap: wrap;
    gap: 12px;
    justify-content: flex-start;
    padding-left: 12px;
    padding-right: 12px;
  }

  .content {
    padding-left: 12px;
    padding-right: 12px;
  }

  /* 常见页面内 1200px 宽容器在移动端铺满 */
  .classCard,
  .carouselImage,
  .works-box,
  .news-box .nwes-card-box,
  .course .classCard,
  .team-box .carouselImage {
    width: 100% !important;
    max-width: 100% !important;
  }

  /* 卡片与栅格在中等屏改两列 */
  .classCard .card,
  .works-box .list-box .card,
  .news-box .nwes-card-box .nwes-card {
    width: calc(50% - 10px) !important;
  }

  /* 轮播高度降低以避免首屏过高 */
  .el-carousel,
  .el-carousel__container {
    height: 280px !important;
  }
}

@media (max-width: 600px) {
  .top-service-bar .brand-wrap {
    gap: 8px;
  }

  .top-service-bar .brand-name {
    font-size: 26px;
  }


  /* 小屏再缩成一列 */
  .works-box .list-box .card,
  .news-box .nwes-card-box .nwes-card {
    width: 100% !important;
  }

  /* 统一图片自适应，覆盖局部固定宽高 */
  img {
    max-width: 100% !important;
    height: auto !important;
  }

  /* 调整标题字号，避免过大 */
  .title,
  .nwes-title {
    font-size: 20px !important;
  }

  /* 底部导航换行展示 */
  .bottom .bottom-type {
    flex-wrap: wrap;
  }

  /* 轮播更小高度 */
  .el-carousel,
  .el-carousel__container {
    height: 200px !important;
  }
}

@media (max-width: 768px) {

  /* 个人中心：侧栏与内容区改为上下布局 */
  .profile-container {
    flex-direction: column !important;
  }

  .profile-container .sidebar {
    width: 100% !important;
  }

  .profile-container .content-area {
    width: 100% !important;
  }

  /* 列表卡片内文案字号稍降，避免换行过多 */
  .works-box .list-box .card .info-box .name,
  .news-box .nwes-card-box .nwes-card .news-info-box .news-title,
  .course .classCard .card p {
    font-size: 14px !important;
  }
}
</style>
